// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import VueLazyLoad from "vue-lazyload";
import App from "@src/App";
import router from "@src/common/router";
import fetch, {
  fetchForm,
  fetchVideo,
  fetchGet,
  fetchDelete,
  fetchDownLoad,
  fetchDaHua
} from "@src/common/lib/axios";
import ElementUI from "element-ui";
import store from "@src/common/lib/store";
import {
  api
} from "@src/common/api";
import log from "@src/common/utils/log";
import config from "@src/common/config";
import i18n from "@src/common/lib/i18n";
import map from "@src/common/utils/map";
import app from "@src/common/utils/app";
import utils from "@src/common/utils";
import Print from "vue-print-nb";
import echarts from "echarts";
// import "swprtspsdk/dist/index.css";

// 引入系统自定义指令
import "@src/common/lib/directives";
// 引入字体和页面样式
import "@src/common/assets/icon/iconfont.css";
import "@src/common/assets/icon-ioc/iconfont.css";
import "@src/common/assets/icon-lunan/iconfont.css";
import "@src/common/assets/icon-menu/iconfont.css";
import "@src/common/assets/icon-lunanAdd/iconfont.css";
import "@src/common/assets/icon-soc/iconfont.css";
import "@src/common/assets/new-icon/iconfont.css";
// import '@src/common/assets/fontFamily/font.css'
import "@src/common/assets/fontFamily/font.css";
// 系统所有公共样式及主题样式入口文件
import "@src/common/assets/style/index.scss";
// 全局filter
import * as filters from "@src/common/filters";
// 表格组件
import IocTable from "@src/components/common/ioc-table";
// 表单组件
import IocForms from "@src/components/common/ioc-forms";
// 页签组件
import IocTabGroup from "@src/components/common/ioc-tab-group";
// 数组，对象操作库
import Lodash from "lodash";
// v-viewer图片查看器
import "viewerjs/dist/viewer.css";
import 'nprogress/nprogress.css'
import Viewer from "v-viewer";
// 自动引入组件
import "./common/config/auto-ui-componets";
// 富文本组件
// import editor from "@src/modules/informationRelease/components/editor"

import dataV from '@jiaminghi/data-view';
Vue.use(dataV);

import Contextmenu from 'vue-contextmenujs';
Vue.use(Contextmenu);

Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 10001
  }
});
Vue.use(VueLazyLoad, {
  error: require("@src/common/assets/images/default.png"),
  loading: require("@src/common/assets/images/default.png"),
  preLoad: 1,
  attempt: 1
});
Vue.use(IocTable);
Vue.use(IocForms);
Vue.use(IocTabGroup);
Vue.use(ElementUI, {
  i18n: (path, value) => i18n.t(path, value),
  size: "small"
});
Vue.use(Print);
Vue.prototype.$echarts = echarts;
Vue.prototype.$fetch = fetch;
Vue.prototype.$fetchDaHua = fetchDaHua; // fetchDaHua
Vue.prototype.$fetchForm = fetchForm;
Vue.prototype.$fetchGet = fetchGet;
Vue.prototype.$fetchDelete = fetchDelete;
Vue.prototype.$fetchDownLoad = fetchDownLoad;
Vue.prototype.$config = config;
Vue.prototype.$fetchVideo = fetchVideo;
Vue.prototype.$api = api;
Vue.prototype.$log = log;
Vue.prototype.$map = map;
Vue.prototype.$app = app;
Vue.prototype.$utils = utils;
Vue.prototype._ = Lodash;
// Vue.component('editor', editor)
// 加载过滤器
Object.keys(Object.assign(filters)).forEach((key) => {
  Vue.filter(key, filters[key]);
});
// 注册到Vue-IOC组件库
Vue.use(window.IOC, {
  i18n: (path, value) => i18n.t(path, value),
  menuType: "text",
  size: "mini"
});
/* eslint-disable no-new */
const vue = new Vue({
  el: "#app",
  router,
  store,
  i18n,
  components: {
    App
  },
  template: "<App/>"
});
//
// 若是没有开启Devtools工具，在开发环境中开启，在生产环境中关闭

if (process.env.NODE_ENV == "development") {
  Vue.config.devtools = true;
} else {
  Vue.config.devtools = false;
}